import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { FiVolumeX } from 'react-icons/fi'
import './Actualite.css'

const NosActualite = () => {
  const [infoac, setInfoac] = useState([])

  useEffect(() => {
    axios(`${process.env.REACT_APP_API_URL}/actualite/lister`).then(res => {
      setInfoac(res.data)
    }).catch(() => {})
  }, [])

  const handleClick = (e) => {
    const video = e.target

    video.muted = false
    video.controls = true

    if (video.requestFullscreen) {
      video.requestFullscreen()
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen()
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen()
    }

    video.classList.add('fullscreen-video')
    video.play()

    const exitHandler = () => {
      if (!document.fullscreenElement &&
          !document.webkitFullscreenElement &&
          !document.msFullscreenElement) {
        video.classList.remove('fullscreen-video')
        document.removeEventListener('fullscreenchange', exitHandler)
        document.removeEventListener('webkitfullscreenchange', exitHandler)
        document.removeEventListener('msfullscreenchange', exitHandler)
      }
    }

    document.addEventListener('fullscreenchange', exitHandler)
    document.addEventListener('webkitfullscreenchange', exitHandler)
    document.addEventListener('msfullscreenchange', exitHandler)
  }

  return (
    <div className='container actualite-container'>
      <motion.div
        className="actualite-header"
        initial={{ opacity: 0, y: -16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <span className="actualite-eyebrow">En ce moment</span>
        <h2 className='titre-actualite'>Nos Actualités</h2>
      </motion.div>

      <div className='row justify-content-center'>
        {infoac.map((info, index) => (
          <motion.div
            className='col-lg-3 col-md-4 col-6 actualite-video'
            key={info._id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: index * 0.06 }}
          >
            <div className="actualite-video-frame">
              <video
                className="video-clip"
                src={info.image}
                autoPlay
                muted
                loop
                playsInline
                onClick={handleClick}
              />
              <span className="actualite-sound-hint">
                <FiVolumeX />
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default NosActualite
